import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Hook that provides debounced search state.
 *
 * Mirrors the DFE arche's hook so LitSquad stays consistent with DFE UX —
 * imported users type and wait for a short debounce before the list re-queries.
 */
export function useDebouncedSearch(delay = 300) {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleSearchChange = useCallback(
    (value: string) => {
      setSearch(value);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setDebouncedSearch(value);
      }, delay);
    },
    [delay],
  );

  return { search, debouncedSearch, handleSearchChange } as const;
}
